import { gql } from '@apollo/client';

const Fragments = {
  approvalType: gql`
    fragment approvalType on ApprovalTypeListItem {
      approvalTypeId
      siteId
      approvalTypeCode
      approvalTypeName
    }
  `
};

export default Fragments;
